// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxlargeOnConfiend-badge-76c520f3"};